import React, { useState, useEffect } from 'react';
import { DateFormatType } from '@/modules/core/domain/interfaces';
import moment from 'moment';
import Main from './Date';
import { DateProps } from './localGeneric';
import { IntervalContainer } from './styles';

export const formatDate = (newInfo: string): string | null => {
  const intParsed = parseInt(newInfo, 10);
  if (!intParsed) return null;
  const parsed = new Date(intParsed * 1000);
  const day: number = parsed.getDate();
  const month: number = parsed.getMonth();
  const currentYear: number = parsed.getFullYear();

  const currentDay: string = day < 10 ? `0${day}` : `${day}`;

  const currentMonth: string = month < 9 ? `0${month + 1}` : `${month + 1}`;

  return ` ${currentDay}/${currentMonth}/${currentYear}`;
};

const DateComponent: React.FC<DateProps> = ({
  onSelect,
  date,
  title,
  minDate,
  dateFormat,
}) => {
  const minSelectableDate: string = minDate || ``;
  const [currentDate, setCurrentDate] = useState<string>(date || '');

  const onChangeDate = (newDate: string) => {
    const parsedDate: string = `${moment(newDate).utc().unix()}`;

    const dateOutput =
      dateFormat === DateFormatType.DEFAULT_TIMESTAMP ? newDate : parsedDate;

    onSelect(dateOutput);
    setCurrentDate(parsedDate);
  };

  useEffect(() => {
    if (!date) {
      setCurrentDate('');
      return;
    }
    const minDate: number = Number(minSelectableDate);
    const selectedDate: number = Number(currentDate);
    const isInvalid: boolean = selectedDate < minDate;
    if (isInvalid) setCurrentDate('');
  }, [minDate, date, currentDate, minSelectableDate]);

  return (
    <IntervalContainer className="datePicker">
      <Main
        name={title}
        min={minSelectableDate}
        onChange={onChangeDate}
        value={currentDate}
        key=""
      />
    </IntervalContainer>
  );
};

export default DateComponent;
